module.exports = __webpack_public_path__ + "img/farming.c108d784.svg";